export default "__VITE_ASSET__BetxsCW2__"